import React from 'react';
import { PaymentMethod } from '../../../../payment-methods/payment-method-selection-dialog';
import { Payment } from '../payment-service-history-list';
import { UserPayment } from '../../../../../../../api/types/students/payment-services/user-payments/user-payment-service-with-price-list';

export interface PaymentDetailsTooltipProps {
  payment: UserPayment;
}
export const PaymentDetailsTooltip: React.FC<PaymentDetailsTooltipProps> = ({
  payment,
}) => {
  if (!payment.paymentDetails) {
    return null;
  }

  const renderDetails = () => {
    const details = payment.paymentDetails!;

    switch (payment.paymentMethodType) {
      case PaymentMethod.BankTransfer:
        return (
          <>
            <div>מספר בנק: {details.bankNumber}</div>
            <div>מספר סניף: {details.branchNumber}</div>
            <div>מספר חשבון: {details.accountNumber}</div>
            {details.transferDate && (
              <div>
                תאריך העברה:{' '}
                {new Date(details.transferDate).toLocaleDateString('he-IL')}
              </div>
            )}
          </>
        );

      case PaymentMethod.Check:
        return (
          <>
            <div>מספר בנק: {details.bankNumber}</div>
            <div>מספר סניף: {details.branchNumber}</div>
            <div>מספר חשבון: {details.accountNumber}</div>
            {details.dueDate && (
              <div>
                תאריך פירעון:{' '}
                {new Date(details.dueDate).toLocaleDateString('he-IL')}
              </div>
            )}
          </>
        );

      case PaymentMethod.Scholarship:
        return <div>מספר מלגה: {details.scholarshipId}</div>;

      default:
        return null;
    }
  };

  return (
    <div
      className="payment-details"
      style={{
        padding: '1rem',
        backgroundColor: '#f8f9fa',
        borderRadius: '8px',
        margin: '0.5rem 0',
        fontSize: '0.9rem',
        color: '#495057',
      }}
    >
      {renderDetails()}
    </div>
  );
};
